import React, { useState } from "react";
import {
  ResponsiveContainer,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Line,
  ComposedChart,
  LabelList,
} from "recharts";
import RelevantReports from "./RelevantReports";
import ResponsiveTable from "./Statisitcs";
import GlobalDataSummary from "./GlobalReport";
import MarketScope from "./MarketScope";
import MarketOutlook from "./MarketOutlook";
import PieChartSection from "./PieChart";
const data = [
  { year: 2018, value: 55.3, percent: 45.3 },
  { year: 2019, value: 58.8, percent: 33.0 },
  { year: 2020, value: 67.5, percent: 33.0 },
  { year: 2021, value: 49.5, percent: 30.0 },
  { year: 2022, value: 45.7, percent: 29.0 },
  { year: 2023, value: 55.9, percent: 29.0 },
  { year: 2024, value: 62.4, percent: 29.0 },
  { year: 2025, value: 79.5, percent: 29.0 },
  { year: 2026, value: 84.3, percent: 29.0 },
];

const cardData = [
  {
    title: "Revenue,",
    year: "2023",
    value: "$22,880.50",
    icon: "images/bag.png",
  },
  {
    title: "Forecast,",
    year: "2030",
    value: "$1,096.30",
    icon: "images/forecast.png",
  },
  {
    title: "CAGR,",
    year: "2024-2030",
    value: "33.98%",
    icon: "images/grow.png",
  },
  {
    title: "World Wide",
    year: "",
    value: "Report",
    icon: "images/send.png",
  },
];

function MarketOverview2() {
  const [activeTab, setActiveTab] = useState("overview");

  const handleDownloads = () => {
    const fileUrl = "/path-to-your-file/report.pdf";
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "comprehensive_report.pdf");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleDownload = () => {
    const content =
      "This is the downloaded content for the market overview report.";

    const blob = new Blob([content], { type: "text/plain" });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "market_overview_report.txt";

    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  return (
    <div className="">
      <div className="mb-8 font-inter">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold font4">
          Global XYZ Market Size Study & Forecast Outlook
        </h1>
        <p className="font14 mt-2 py-1 text-sm sm:text-base tracking-wide">
          The spatial genomics & transcriptomics industry worldwide is expected
          to reach a projected revenue of US$ 631.7 million by 2030. A compound
          annual growth rate of 10.7% is expected of the worldwide spatial
          genomics & transcriptomics industry from 2024 to 2030.
        </p>
      </div>
      {activeTab === "overview" ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 md:gap-7 gap-4 font-inter">
          {cardData.map((card, index) => (
            <div
              key={index}
              className="bg-white border1 p-4 sm:p-6 md:p-7 rounded-xl shadow flex items-center justify-between transition-all duration-300 ease-in-out hover:shadow-lg hover:scale-105 w-full"
            >
              <div className="flex flex-col">
                <p className="font-medium text-xs sm:text-sm font14">
                  {card.title}
                  {card.year && (
                    <span className="font15 ml-1">{card.year}</span>
                  )}
                </p>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mt-1 font16">
                  {card.value}
                </h3>
              </div>
              <img
                src={card.icon}
                alt={card.title}
                className="w-6 h-5 sm:w-8 sm:h-7 object-contain"
              />
            </div>
          ))}
        </div>
      ) : (
        <div>
          <button
            onClick={handleDownloads}
            className="bg-black text-white py-3 px-4 rounded-lg mb-2 font-inter text-sm hover:bg-[#21242a]"
          >
            Download comprehensive report
          </button>
        </div>
      )}

      {/* Tabs */}
      <div className="flex space-x-4 border3 mt-4 mb-4">
        <button
          className={`py-2 px-4  font-inter ${
            activeTab === "overview"
              ? "border2 font2 font-semibold"
              : "text-black"
          }`}
          onClick={() => setActiveTab("overview")}
        >
          Overview
        </button>
        <button
          className={`py-2 px-4  font-inter ${
            activeTab === "statistics"
              ? "border2 font2  font-semibold"
              : "text-black"
          }`}
          onClick={() => setActiveTab("statistics")}
        >
          Statistics
        </button>
      </div>

      {activeTab === "overview" ? (
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-5 mt-8">
            <div className="lg:col-span-3 bg-white p-6 rounded-xl shadow border1 h-fit">
              <div className=" mb-4 flex flex-col lg:flex-row items-center justify-between font-inter">
                <h2 className="text-xl font-bold max-w-lg font4">
                  Global spatial genomics & transcriptomics market, 2018-2030
                  (US$M)
                </h2>
                <div className="text-center mb-2">
                  <button
                    onClick={handleDownload}
                    className="bg-black text-white px-14 py-2 rounded-xl hover:bg-[#21242a] font-semibold"
                  >
                    Download
                  </button>
                </div>
              </div>
              <div className="overflow-x-auto">
                <div
                  style={{ width: `${data.length * 62}px`, minWidth: "100%" }}
                >
                  <ResponsiveContainer
                    width="100%"
                    height={300}
                    style={{ fontFamily: "Poppins, sans-serif" }}
                  >
                    <ComposedChart data={data}>
                      <CartesianGrid strokeDasharray="3 3" vertical={false} />
                      <XAxis dataKey="year" tickLine={false} axisLine={false} />
                      <YAxis
                        yAxisId="left"
                        axisLine={false}
                        tickLine={false}
                        tick={{
                          fill: "#000000",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      />

                      <YAxis
                        yAxisId="right"
                        orientation="right"
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(value) => `${value.toFixed(1)}%`}
                        tick={{
                          fill: "#000000",
                          fontFamily: "Poppins, sans-serif",
                        }}
                      />

                      <Tooltip />

                      <Bar
                        dataKey="value"
                        fill="#923351"
                        width={42}
                        yAxisId="left"
                        shape={(props) => {
                          const { x, y, width, height } = props;
                          return (
                            <g>
                              <defs>
                                <filter
                                  id="shadow"
                                  x="-20%"
                                  y="-20%"
                                  width="140%"
                                  height="140%"
                                >
                                  <feDropShadow
                                    dx="2"
                                    dy="2"
                                    stdDeviation="3"
                                    floodOpacity="0.3"
                                  />
                                </filter>
                              </defs>
                              <rect
                                x={x}
                                y={y}
                                width={width}
                                height={height}
                                rx={5}
                                ry={5}
                                fill="#923351"
                                filter="url(#shadow)"
                              />
                            </g>
                          );
                        }}
                        barSize={42}
                        barGap={4}
                      >
                        <LabelList
                          dataKey="value"
                          position="top"
                          fill="#000000"
                          fontFamily="Poppins, sans-serif"
                        />
                      </Bar>
                      <Line
                        type="monotone"
                        dataKey="percent"
                        stroke="#ff9c40"
                        strokeWidth={2}
                        dot={{ r: 0 }}
                        yAxisId="right"
                      />
                    </ComposedChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
            <div className=" lg:col-span-1 ">
              <button
                onClick={handleDownloads}
                className="bg-black text-white py-3 px-4 rounded-lg w-full mb-2 font-inter text-sm hover:bg-[#21242a]"
              >
                Download comprehensive report
              </button>
              <RelevantReports />
            </div>
            <div className="bg-white lg:col-span-3 p-6 rounded-xl shadow border1 -mt-24 font-inter h-fit">
              <h3 className="text-xl font-bold mb-4 font4">
                Global XYZ market Insights
              </h3>
              <p className="font14 mb-6">
                The spatial genomics & transcriptomics industry worldwide is
                expected to reach a projected revenue of US$ 631.7 million by
                2030. A compound annual growth rate of 10.7% is expected of the
                worldwide spatial genomics & transcriptomics industry from 2024
                to 2030.
              </p>
              <ul className="list-disc pl-6 font14 space-y-3">
                <li>
                  The global spatial genomics & transcriptomics market generated
                  a revenue of USD 310.0 million in 2023 and is expected to
                  reach USD 631.7 million by 2030.
                </li>
                <li>
                  The market is expected to grow at a CAGR (2024 - 2030) of
                  10.7% by 2030.
                </li>
                <li>
                  In terms of segment, consumables accounted for a revenue of
                  USD 163.5 million in 2023.
                </li>
                <li>
                  PVDF is the most lucrative product segment registering the
                  fastest growth during the forecast period.
                </li>
                <li>
                  In terms of region, North America was the largest revenue
                  generating market in 2023.
                </li>
                <li>
                  Country-wise, Kuwait is expected to register the highest CAGR
                  from 2024 to 2030.
                </li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-xl shadow border1 font-inter h-fit">
              <h3 className="text-lg font-bold mb-4 font4">
                Bizwit at a Glance
              </h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center gap-2 ">
                  <img
                    src="images/check_circle.png"
                    alt="ff"
                    className="w-5 h-5"
                  />
                  40K+ Comprehensive Market Reports
                </li>
                <li className="flex items-center gap-2">
                  <img
                    src="images/check_circle.png"
                    alt="ff"
                    className="w-5 h-5"
                  />
                  150K+ Country-Specific Reports
                </li>
                <li className="flex items-center gap-2 ">
                  <img
                    src="images/check_circle.png"
                    alt="ff"
                    className="w-5 h-5"
                  />
                  1.5M+ Market Data Points
                </li>
                <li className="flex items-center gap-2 ">
                  <img
                    src="images/check_circle.png"
                    alt="ff"
                    className="w-5 h-5"
                  />
                  250K+ Company Analyses
                </li>
              </ul>
              <button className="mt-6 bg-[#15171a] text-white py-3 px-4 rounded-lg w-full font-dmSans text-base font-semibold hover:bg-[#21242a]">
                Ask a question
              </button>
            </div>
          </div>
          <GlobalDataSummary />
          <MarketScope />
          <MarketOutlook />
          <PieChartSection />
        </div>
      ) : (
        <div>
          <div className="bg-white overflow-hidden  my-8 rounded-xl shadow">
            <ResponsiveTable />
          </div>

          <div className="bg-white overflow-hidden rounded-xl shadow">
            <ResponsiveTable />
          </div>
        </div>
      )}
    </div>
  );
}

export default MarketOverview2;
